/**
 * Generated by orval v7.9.0 🍺
 * Do not edit manually.
 * Pizza Checker API
 * OpenAPI spec version: 1.0.0
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  PostCreateUserBody,
  PostGetUsersBody,
  PostGetUsersByBranchBody,
  PutUpdateUserBody,
} from ".././schemas";

import { customInstance } from "../../axios-instance";
import type { ErrorType, BodyType } from "../../axios-instance";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary Create new user
 */
export const postCreateUser = (
  postCreateUserBody: BodyType<PostCreateUserBody>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<unknown>(
    {
      url: `/api/admin/users/create`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: postCreateUserBody,
      signal,
    },
    options,
  );
};

export const getPostCreateUserMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postCreateUser>>,
    TError,
    { data: BodyType<PostCreateUserBody> },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postCreateUser>>,
  TError,
  { data: BodyType<PostCreateUserBody> },
  TContext
> => {
  const mutationKey = ["postCreateUser"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postCreateUser>>,
    { data: BodyType<PostCreateUserBody> }
  > = (props) => {
    const { data } = props ?? {};

    return postCreateUser(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostCreateUserMutationResult = NonNullable<
  Awaited<ReturnType<typeof postCreateUser>>
>;
export type PostCreateUserMutationBody = BodyType<PostCreateUserBody>;
export type PostCreateUserMutationError = ErrorType<unknown>;

/**
 * @summary Create new user
 */
export const usePostCreateUser = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postCreateUser>>,
      TError,
      { data: BodyType<PostCreateUserBody> },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postCreateUser>>,
  TError,
  { data: BodyType<PostCreateUserBody> },
  TContext
> => {
  const mutationOptions = getPostCreateUserMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Get paginated list of users
 */
export const postGetUsers = (
  postGetUsersBody: BodyType<PostGetUsersBody>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<unknown>(
    {
      url: `/api/admin/users/list`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: postGetUsersBody,
      signal,
    },
    options,
  );
};

export const getPostGetUsersQueryKey = (postGetUsersBody: PostGetUsersBody) => {
  return [`/api/admin/users/list`, postGetUsersBody] as const;
};

export const getPostGetUsersQueryOptions = <
  TData = Awaited<ReturnType<typeof postGetUsers>>,
  TError = ErrorType<unknown>,
>(
  postGetUsersBody: PostGetUsersBody,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof postGetUsers>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getPostGetUsersQueryKey(postGetUsersBody);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof postGetUsers>>> = ({
    signal,
  }) => postGetUsers(postGetUsersBody, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof postGetUsers>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type PostGetUsersQueryResult = NonNullable<
  Awaited<ReturnType<typeof postGetUsers>>
>;
export type PostGetUsersQueryError = ErrorType<unknown>;

export function usePostGetUsers<
  TData = Awaited<ReturnType<typeof postGetUsers>>,
  TError = ErrorType<unknown>,
>(
  postGetUsersBody: PostGetUsersBody,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof postGetUsers>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof postGetUsers>>,
          TError,
          Awaited<ReturnType<typeof postGetUsers>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function usePostGetUsers<
  TData = Awaited<ReturnType<typeof postGetUsers>>,
  TError = ErrorType<unknown>,
>(
  postGetUsersBody: PostGetUsersBody,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof postGetUsers>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof postGetUsers>>,
          TError,
          Awaited<ReturnType<typeof postGetUsers>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function usePostGetUsers<
  TData = Awaited<ReturnType<typeof postGetUsers>>,
  TError = ErrorType<unknown>,
>(
  postGetUsersBody: PostGetUsersBody,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof postGetUsers>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get paginated list of users
 */

export function usePostGetUsers<
  TData = Awaited<ReturnType<typeof postGetUsers>>,
  TError = ErrorType<unknown>,
>(
  postGetUsersBody: PostGetUsersBody,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof postGetUsers>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getPostGetUsersQueryOptions(postGetUsersBody, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get paginated list of users by branch
 */
export const postGetUsersByBranch = (
  postGetUsersByBranchBody: BodyType<PostGetUsersByBranchBody>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<unknown>(
    {
      url: `/api/admin/users/list-by-branch`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: postGetUsersByBranchBody,
      signal,
    },
    options,
  );
};

export const getPostGetUsersByBranchMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postGetUsersByBranch>>,
    TError,
    { data: BodyType<PostGetUsersByBranchBody> },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postGetUsersByBranch>>,
  TError,
  { data: BodyType<PostGetUsersByBranchBody> },
  TContext
> => {
  const mutationKey = ["postGetUsersByBranch"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postGetUsersByBranch>>,
    { data: BodyType<PostGetUsersByBranchBody> }
  > = (props) => {
    const { data } = props ?? {};

    return postGetUsersByBranch(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostGetUsersByBranchMutationResult = NonNullable<
  Awaited<ReturnType<typeof postGetUsersByBranch>>
>;
export type PostGetUsersByBranchMutationBody =
  BodyType<PostGetUsersByBranchBody>;
export type PostGetUsersByBranchMutationError = ErrorType<unknown>;

/**
 * @summary Get paginated list of users by branch
 */
export const usePostGetUsersByBranch = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postGetUsersByBranch>>,
      TError,
      { data: BodyType<PostGetUsersByBranchBody> },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postGetUsersByBranch>>,
  TError,
  { data: BodyType<PostGetUsersByBranchBody> },
  TContext
> => {
  const mutationOptions = getPostGetUsersByBranchMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Get user by ID
 */
export const getUser = (
  userId: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<unknown>(
    { url: `/api/admin/users/${userId}`, method: "GET", signal },
    options,
  );
};

export const getGetUserQueryKey = (userId: string) => {
  return [`/api/admin/users/${userId}`] as const;
};

export const getGetUserQueryOptions = <
  TData = Awaited<ReturnType<typeof getUser>>,
  TError = ErrorType<unknown>,
>(
  userId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getUser>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetUserQueryKey(userId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getUser>>> = ({
    signal,
  }) => getUser(userId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!userId,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getUser>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type GetUserQueryResult = NonNullable<
  Awaited<ReturnType<typeof getUser>>
>;
export type GetUserQueryError = ErrorType<unknown>;

export function useGetUser<
  TData = Awaited<ReturnType<typeof getUser>>,
  TError = ErrorType<unknown>,
>(
  userId: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getUser>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUser>>,
          TError,
          Awaited<ReturnType<typeof getUser>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUser<
  TData = Awaited<ReturnType<typeof getUser>>,
  TError = ErrorType<unknown>,
>(
  userId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getUser>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUser>>,
          TError,
          Awaited<ReturnType<typeof getUser>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUser<
  TData = Awaited<ReturnType<typeof getUser>>,
  TError = ErrorType<unknown>,
>(
  userId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getUser>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get user by ID
 */

export function useGetUser<
  TData = Awaited<ReturnType<typeof getUser>>,
  TError = ErrorType<unknown>,
>(
  userId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getUser>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetUserQueryOptions(userId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Update user - only updates provided fields (PUT style)
 */
export const putUpdateUser = (
  userId: string,
  putUpdateUserBody: BodyType<PutUpdateUserBody>,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<unknown>(
    {
      url: `/api/admin/users/${userId}`,
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      data: putUpdateUserBody,
    },
    options,
  );
};

export const getPutUpdateUserMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putUpdateUser>>,
    TError,
    { userId: string; data: BodyType<PutUpdateUserBody> },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putUpdateUser>>,
  TError,
  { userId: string; data: BodyType<PutUpdateUserBody> },
  TContext
> => {
  const mutationKey = ["putUpdateUser"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putUpdateUser>>,
    { userId: string; data: BodyType<PutUpdateUserBody> }
  > = (props) => {
    const { userId, data } = props ?? {};

    return putUpdateUser(userId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutUpdateUserMutationResult = NonNullable<
  Awaited<ReturnType<typeof putUpdateUser>>
>;
export type PutUpdateUserMutationBody = BodyType<PutUpdateUserBody>;
export type PutUpdateUserMutationError = ErrorType<unknown>;

/**
 * @summary Update user - only updates provided fields (PUT style)
 */
export const usePutUpdateUser = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putUpdateUser>>,
      TError,
      { userId: string; data: BodyType<PutUpdateUserBody> },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof putUpdateUser>>,
  TError,
  { userId: string; data: BodyType<PutUpdateUserBody> },
  TContext
> => {
  const mutationOptions = getPutUpdateUserMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
